<template>
  <div id="app">
   
     <router-view >
      
     </router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  data (){
    return{
      
    }
  },
  mounted(){
   
  },
  methods:{
    
  }
}
</script>

<style>
* {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
#app{
  font-family: 'Kanit', Helvetica, Arial, 'PingFang SC', 'Microsoft Yahei', sans-serif;
}
*{
  margin: 0;
  padding: 0;
}
.email, .link-item a{
  text-decoration: none;
}
li{
  list-style: none;
}
</style>
